var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRegisterationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_27_2",
    "data-name": "Component 27 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.462,
    height: 17.019,
    viewBox: "0 0 16.462 17.019",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_23214",
    "data-name": "Path 23214",
    d: "M18.113,13.746,15.5,11.44l.476-.536,3.562,3.206-3.562,3.206-.476-.588,2.616-2.251H12.494l-.073-.731Z",
    transform: "translate(-3.073 -0.296)",
    fill: "#2e384d"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7057",
    "data-name": "Group 7057",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23214-2",
    "data-name": "Path 23214",
    d: "M12.268,11.74v1.694a5.044,5.044,0,0,0-4.518.614,4.834,4.834,0,0,0-2.1,3.971H4a6.439,6.439,0,0,1,2.563-5.127,6.719,6.719,0,0,1,5.7-1.152Zm-1.654-1.015A4.911,4.911,0,0,1,5.654,5.863a4.962,4.962,0,0,1,9.921,0A4.911,4.911,0,0,1,10.614,10.725Zm0-1.621a3.274,3.274,0,0,0,3.307-3.242,3.308,3.308,0,0,0-6.614,0A3.274,3.274,0,0,0,10.614,9.1Z",
    transform: "translate(-4 -1)",
    fill: "#2e384d"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisterationIcon);
export default __webpack_public_path__ + "static/media/registeration-icon.b0bb3b5203e717e78f7503a4a00faef4.svg";
export { ForwardRef as ReactComponent };